(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracPackageDialogController', NasracPackageDialogController);

    NasracPackageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'NasracPackage'];

    function NasracPackageDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, NasracPackage) {
        var vm = this;

        vm.nasracPackage = entity;
        vm.clear = clear;
        vm.save = save;
        vm.showMissingNumbrs = true;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.nasracPackage.id !== null) {
                NasracPackage.update(vm.nasracPackage, onSaveSuccess, onSaveError);
            } else {
                NasracPackage.save(vm.nasracPackage, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('nasracApp:nasracPackageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.findPackageList = function  () {

            NasracPackage.query(vm.nasracPackage, onGetSuccess, onGetError);

        };

        function onGetSuccess (result) {
            vm.unusedPckList = findMissingNumbers(result);
        }

        function findMissingNumbers(result) {

            var a = [];
             var missingList = [];
            var missingRangeList = [];
            for(var i=0;i<result.length;i++){
                a.push(result[i].packageBsgHandle);
            }
            a = a.sort(function (e1, e2) {  return e1 - e2;  });

            var numberExists = true;
            var missingRange = "";
            var j = a[0];
            for (var i=0;i<a.length;i++)
            {
                if (j==a[i])
                {
                    if(!numberExists){
                        numberExists = !numberExists;
                        missingRange = missingRange +""+ (missingRange == j-1 ? "" : " - "+(j-1).toString() );
                        missingRangeList.push(missingRange);
                        missingRange = "";
                    }
                    numberExists = true;
                    j++;
                    continue;
                }
                else
                {
                    if(numberExists){
                        numberExists = !numberExists;
                        missingRange = j;
                    }
                    numberExists = false;
                     missingList.push(j);
                    i--;
                    j++;
                }
            }
            return missingList;

        }

        function onGetError (error) {
            //Error code here
        }
        vm.findPackageList();

        vm.bindVal = function(s){
            vm.showMissingNumbrs = false;
            vm.nasracPackage.packageBsgHandle = s;
        };

        vm.pckBsgChanged = function(){
            vm.showMissingNumbrs = true;

        };

    }
})();
